export const COMPANY_TYPES = {
  ACTION_SOCIETY: 'ACTION_SOCIETY',
  LIMITED_SOCIETY: 'LIMITED_SOCIETY',
  ANONYMOUS_SOCIETY: 'ANONYMOUS_SOCIETY',
  INDIVIDUAL_SOCIETY: 'INDIVIDUAL_SOCIETY',
  NATURAL_PERSON: 'NATURAL_PERSON',
};

export const COMPANY_TYPE_LABELS = {
  [COMPANY_TYPES.ACTION_SOCIETY]: 'Soc. por Acciones',
  [COMPANY_TYPES.LIMITED_SOCIETY]: 'Soc. Limitada',
  [COMPANY_TYPES.ANONYMOUS_SOCIETY]: 'Soc. Anónima',
  [COMPANY_TYPES.INDIVIDUAL_SOCIETY]: 'E.I.R.L.',
  [COMPANY_TYPES.NATURAL_PERSON]: 'Persona Natural',
};

